import Inputmask from 'inputmask'
import { Options as InputmaskOptions } from 'inputmask'

interface IMaskDynamicOptions {
  maskPattern: string
  maskOptions?: InputmaskOptions
  selectorOrElement: string | HTMLElement
}

class InputMask {
  public static maskDynamic(options: IMaskDynamicOptions) {
    Inputmask(options.maskPattern, options.maskOptions).mask(options.selectorOrElement)
  }

  constructor() {
    this.init()
  }

  public maskPhone() {
    Inputmask('+7 (999) 999-99-99').mask('[data-module="maskedPhone"]')
  }

  public maskBirthday() {
    Inputmask('99-99-9999').mask('[data-module="maskedBirthday"]')
  }

  public maskCreditCardDateChunk() {
    Inputmask('99', { placeholder: ' '}).mask('[data-module="maskedCreditCardDateChunk"]')
  }

  public maskInn() {
    Inputmask('9999999999[99]').mask('[data-module="maskedInn"]')
  }

  public maskPassport() {
    Inputmask('9999 999999').mask('[data-module="maskedPassport"]')
  }

  public maskPassportSeries() {
    Inputmask('9999').mask('[data-module="maskedPassportSeries"]')
  }

  public maskPassportNum() {
    Inputmask('999999').mask('[data-module="maskedPassportNum"]')
  }

  public maskPassportCode() {
    Inputmask('999-999').mask('[data-module="maskedPassportCode"]')
  }

  public maskKpp() {
    Inputmask('*********').mask('[data-module="maskedKpp"]')
  }

  public maskOgrn() {
    Inputmask('9999999999999[99]').mask('[data-module="maskedOgrn"]')
  }

  public maskSnils() {
    Inputmask('999 999 999 99').mask('[data-module="maskedSnils"]')
  }

  public maskSum() {
    Inputmask('decimal', {
      autoGroup: true,
      digits: '20',
      groupSeparator: ' ',
      groupSize: 3,
      integerDigits: '20',
      radixPoint: ',',
      rightAlign: false,
    }).mask('[data-module="maskedSum"]')
  }

  public maskDigits() {
    Inputmask({
      placeholder: '',
      regex: '[0-9]+',
    }).mask('[data-module="maskedDigits"]')
  }

  public maskRus() {
    Inputmask({
      placeholder: '',
      regex: '[-а-яА-Я]+',
    }).mask('[data-module="maskedRus"]')
  }

  public maskLatin() {
    Inputmask({
      placeholder: '',
      regex: '[a-zA-Z]+',
    }).mask('[data-module="maskedLatin"]')
  }

  public maskDate() {
    Inputmask('99.99.9999').mask('[data-module="maskedDate"]')
  }

  private init() {
    this.maskPhone()
    this.maskBirthday()
    this.maskCreditCardDateChunk()
    this.maskDate()
    this.maskDigits()
    this.maskInn()
    this.maskPassport()
    this.maskPassportSeries()
    this.maskPassportNum()
    this.maskPassportCode()
    this.maskKpp()
    this.maskOgrn()
    this.maskSnils()
    this.maskSum()
    this.maskRus()
    this.maskLatin()
  }
}

export { InputMask }
